var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("div", { staticClass: "dropdown nodro item" }, [
        _c("i", { staticClass: "fas fa-spinner spin" })
      ])
    : _vm.processStatus === _vm.DOCUMENT_RPOCESS_STATUS.PENDING
    ? _c("BaseActionDropdown", {
        attrs: {
          className: "text-warning",
          icon: "far fa-circle",
          text: _vm.$t("status." + _vm.docType + ".pending"),
          items: _vm.statusOptions
        },
        on: { onSelect: _vm.handleSelect }
      })
    : _c(
        "div",
        { staticClass: "dropdown nodro item" },
        [
          _c("BaseDocumentProcessStatus", {
            attrs: { docType: _vm.docType, status: _vm.processStatus }
          })
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1fdf3f60", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fdf3f60","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseActionUpdateStatus.vue
// module id = null
// module chunks = 